import { useEffect, useState } from "react";

export default function useIOSInstall() {
  const [showIOSBanner, setShowIOSBanner] = useState(false);

  useEffect(() => {
    const isIOS =
      /iphone|ipad|ipod/i.test(navigator.userAgent) &&
      !window.matchMedia("(display-mode: standalone)").matches;

    setShowIOSBanner(isIOS);
  }, []);

  return { showIOSBanner };
}
